import PropTypes from 'prop-types'

const propTypes = PropTypes.shape({
  type: PropTypes.string,
  status: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  update: PropTypes.string,
})

export default propTypes
